import React, { useContext } from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FlexView from 'react-flexview/lib'
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../services/FirebaseService'
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import dayjs from 'dayjs'
import { WorldWideOption } from '../../../models/insurance-models/WorldWideOption'
import { isCanada } from '../../../services/utils'

export const GuidelinesSummarySection = () => {
    const insuranceContext = useContext(InsurancePurchaseContextStore)
    const offersContext = useContext(BuyingInsuranceContextStore)

    if (!FirebaseService.getValue(FirebaseConfigKey.GUIDELINES_STRINGS_JSON)) {
        return null
    }

    const removeHomeBuiltGuidelineForLiabilityOnlyCoverage = (
        permanentGuidelineStrings
    ) => {
        if (
            (permanentGuidelineStrings &&
                !insuranceContext.selectedOption.drones) ||
            insuranceContext.selectedOption.drones.length == 0
        ) {
            permanentGuidelineStrings[0] = permanentGuidelineStrings[0].replace(
                ', and is not home built',
                ''
            )
        }
    }

    let permanentStrings = FirebaseService.getObject(
        FirebaseConfigKey.GUIDELINES_STRINGS_JSON
    )['permanentStrings']
    removeHomeBuiltGuidelineForLiabilityOnlyCoverage(permanentStrings)

    let guidelines = [
        ...permanentStrings,
        ...(insuranceContext.selectedOption.billingPeriod ==
        InsuranceBillingPeriod.MONTH
            ? FirebaseService.getObject(
                  FirebaseConfigKey.GUIDELINES_STRINGS_JSON
              )['monthlyOnlyStrings']
            : []),
        ...(insuranceContext.selectedOption.billingPeriod ==
        InsuranceBillingPeriod.YEAR
            ? FirebaseService.getObject(
                  FirebaseConfigKey.GUIDELINES_STRINGS_JSON
              )['annualOnlyStrings']
            : []),
    ]

    if (
        insuranceContext.selectedOption.territorialLimits ==
            WorldWideOption.Custom &&
        isCanada()
    )
        guidelines = guidelines.map((text: String) =>
            text.replace('within Canada', 'within Canada and the US')
        )

    let starts = offersContext.subscriptionStartTime
        ? `on ${dayjs(offersContext.subscriptionStartTime).format(
              'MMMM D, YYYY'
          )}`
        : 'now'

    let ends =
        insuranceContext.selectedOption.billingPeriod ==
        InsuranceBillingPeriod.MONTH
            ? 'ends in 1 month'
            : 'ends in 1 year'

    guidelines.push(`Your coverage starts ${starts} and ${ends}`)

    if (insuranceContext.selectedOption.dronePremium > 0)
        guidelines.push(
            'Hull coverage includes physical damage caused by an electrical malfunction in flight; however, mechanical failure on the ground is not included.'
        )

    return (
        <Accordion elevation={0} className="summary-expansion transparent">
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <FlexView className="space-between full-width">
                    <div className="text-small gray">Guidelines</div>
                    <div className="text-small gray">Read more</div>
                </FlexView>
            </AccordionSummary>
            <AccordionDetails>
                <ul>
                    {guidelines.map((item, index) => (
                        <li
                            key={index}
                            className="text-tiny margin-top-small black"
                        >
                            {item}
                        </li>
                    ))}
                </ul>
            </AccordionDetails>
        </Accordion>
    )
}
